// src/views/SettingsView.js

import React from 'react';
import { useSettings } from '../components/Settings/SettingsContext';
import { Link } from 'react-router-dom';
import ModeToggle from '../components/Settings/ModeToggle';
import MultiChoiceToggle from '../components/Settings/MultiChoiceToggle';

const SettingsView = () => {
    const {
        isLearningMode,
        toggleLearningMode,
        forceMultiChoice,
        setForceMultiChoice,
        requiredRepetitions,
        setRequiredRepetitions
    } = useSettings();

    const handleRepetitionsChange = (e) => {
        setRequiredRepetitions(Number(e.target.value));
    };

    return (
        <div>
            <h2>Ustawienia aplikacji</h2>
            <div>
                <ModeToggle isLearningMode={isLearningMode} toggleMode={toggleLearningMode} />
            </div>
            <div>
                <MultiChoiceToggle
                    forceMultiChoice={forceMultiChoice}
                    setForceMultiChoice={setForceMultiChoice}
                />
            </div>
            {isLearningMode && (
                <div>
                    <label>
                        Ile razy musisz poprawnie odpowiedzieć na każde pytanie, żeby je uznać za nauczone?&nbsp;
                        <select value={requiredRepetitions} onChange={handleRepetitionsChange}>
                            <option value={1}>1 raz</option>
                            <option value={2}>2 razy</option>
                            <option value={3}>3 razy</option>
                            <option value={5}>5 razy</option>
                        </select>
                    </label>
                </div>
            )}
            <Link to="/" style={{ display: 'block', marginTop: 32 }}>
                <button>Powrót do strony głównej</button>
            </Link>
        </div>
    );
};

export default SettingsView;
